export const UI_CONFIG_SET_REFRESH_INTERVAL = 'UI_CONFIG_SET_REFRESH_INTERVAL';
export const UI_CONFIG_RESET = 'UI_CONFIG_RESET'; 